import { Reveal } from "@/components/Reveal";
import { RECOGNITION_EXPERIENCES } from "@/content";

const Recognition = () => (
  <section data-testid="recognition-section" className="border-t border-stone/60 bg-white/50">
    <div className="mx-auto max-w-6xl px-6 md:px-10 py-28 md:py-40">
      <div className="grid md:grid-cols-12 gap-12 md:gap-8">
        <div className="md:col-span-5">
          <Reveal>
            <p className="eyebrow mb-6">Recognition</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.1]" data-testid="recognition-headline">
              Maybe this is you.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-base md:text-lg leading-relaxed text-taupe max-w-md">
              You’re functioning. You’re handling everything. You’re showing up.
            </p>
            <p className="mt-4 text-base md:text-lg leading-relaxed text-taupe max-w-md">
              But underneath it all, your body feels like it’s always preparing
              for something.
            </p>
          </Reveal>
        </div>

        <div className="md:col-span-6 md:col-start-7">
          <ul data-testid="recognition-experiences-list">
            {RECOGNITION_EXPERIENCES.map((item, i) => (
              <Reveal key={item} delay={0.06 * i} y={16}>
                <li className="flex items-baseline gap-6 border-t border-stone/80 py-5 md:py-6 first:border-t-0 md:first:border-t">
                  <span className="font-sans text-[10px] tracking-[0.3em] text-teal shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-serif text-xl md:text-2xl text-charcoal/90 leading-snug">
                    {item}
                  </span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>

      <Reveal delay={0.1} className="mt-24 md:mt-36 text-center">
        <div className="mx-auto h-px w-14 bg-teal mb-10" aria-hidden="true" />
        <p className="font-serif italic text-3xl md:text-5xl leading-[1.25] tracking-tight text-charcoal max-w-3xl mx-auto" data-testid="recognition-statement">
          Your body isn’t working against you.
          <br />
          <span className="text-deepteal">It’s trying to protect you.</span>
        </p>
      </Reveal>
    </div>
  </section>
);

export default Recognition;
